import axios from 'axios'
import router from '../routers'
import Cookie from '@/services/cookie'

const service = axios.create()
service.defaults.baseURL = window.origin + '/api-v2'
service.defaults.headers.common['Content-Type'] = 'application/json'
service.defaults.headers.common['Accept'] = 'application/json'

service.interceptors.request.use(function(config) {
    let token = Cookie.getAuthToken()
    if (token) {
        config.headers.common['Authorization'] = token
    }

    if (Cookie.getToken('_chat_auth_representation')) {
        config.headers.common['X-Chat-Auth-Representation'] = Cookie.getToken('_chat_auth')
    }

    return config
})

service.interceptors.response.use((response) => {
    return response
    }, (e) => {
        if (e?.response?.data?.error) {
            const { error } = e.response.data
            switch (error) {
                case 'OperatingHoursInvalidException':
                    router.push( { name: 'expired-access' } )
                    throw new Error(error.message)

                // TODO: Implement more types of errors
            }
        }
        return Promise.reject(e)
    })

export default service
